import { Component, OnInit } from '@angular/core';
import { AgentService } from '../../services/agent.service';
import { Agent } from '../../models/agent';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DialogComponent } from '../dialog/dialog.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-agents',
  imports: [CommonModule, RouterModule, DialogComponent, FormsModule],
  templateUrl: './agents.component.html',
  styleUrl: './agents.component.css'
})
export class AgentsComponent implements OnInit {
  public agents: Agent[] = [];

  public newAgent: Agent;
  public showAddAgentDialog: boolean = false;
  public showUnexpectedError: boolean = false;
  public showLoading: boolean = false;

  constructor(private agentService: AgentService) {
    this.newAgent = new Agent();
  }

  ngOnInit(): void {
    this.showLoading = true;
    this.agentService.getAgents().subscribe({
      next: (result) => {
        this.showLoading = false;
        this.agents = result;
      },
      error: (err) => {
        this.showLoading = false;
        // 401s are handled globally by the jwt interceptor (logout + redirect home)
        if (err.status != 401) {
          this.showUnexpectedError = true;
        }
      }
    })
  }

  AddAgent(): void {
    this.agentService.addAgent(this.newAgent).subscribe({
      next: (result) => {
        this.agents.push(result);
        this.showAddAgentDialog = false;
        this.newAgent = new Agent();
      },
      error: (err) => {
        console.log(err);
      }
    });
  }


}
